"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Image_1 = __importDefault(require("../Image"));
var placeHolder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=';
var loaded = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n      opacity: 0.1;\n    }\n  to {\n      opacity: 1;\n    }\n"], ["\n  from {\n      opacity: 0.1;\n    }\n  to {\n      opacity: 1;\n    }\n"])));
var StyledImage = (0, styled_components_1.default)(Image_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* display: block;\n  min-height: ", ";\n  width: 100%;\n  max-width: 100%; */\n  &.loaded:not(.has-error) {\n    min-width: 0;\n    min-height: 0;\n    animation: ", " 300ms ease-in-out;\n  }\n  /* &.has-error {\n    height: 100%;\n    width: 100%;\n  } */\n"], ["\n  /* display: block;\n  min-height: ", ";\n  width: 100%;\n  max-width: 100%; */\n  &.loaded:not(.has-error) {\n    min-width: 0;\n    min-height: 0;\n    animation: ", " 300ms ease-in-out;\n  }\n  /* &.has-error {\n    height: 100%;\n    width: 100%;\n  } */\n"])), function (_a) {
    var height = _a.height;
    return height;
}, loaded);
var LazyImage = function (_a) {
    var src = _a.src, alt = _a.alt, _b = _a.width, width = _b === void 0 ? '100px' : _b, _c = _a.height, height = _c === void 0 ? '100px' : _c, rest = __rest(_a, ["src", "alt", "width", "height"]);
    var _d = (0, react_1.useState)(placeHolder), imageSrc = _d[0], setImageSrc = _d[1];
    var _e = (0, react_1.useState)({
        loaded: false,
        'has-error': false,
    }), classes = _e[0], setClasses = _e[1];
    var imgRef = (0, react_1.useRef)(null);
    var onLoad = function () {
        setClasses(__assign(__assign({}, classes), { loaded: true }));
    };
    var onError = function () {
        setClasses(__assign(__assign({}, classes), { 'has-error': true }));
    };
    (0, react_1.useEffect)(function () {
        var observer;
        var didCancel = false;
        if (imgRef && imgRef.current && imageSrc !== src) {
            if (IntersectionObserver) {
                observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (!didCancel && (entry.intersectionRatio > 0 || entry.isIntersecting)) {
                            setImageSrc(src);
                            if (imgRef.current)
                                observer.unobserve(imgRef.current);
                        }
                    });
                }, {
                    threshold: 0.01,
                    rootMargin: '75%',
                });
                observer.observe(imgRef.current);
            }
            else {
                // Old browsers fallback
                setImageSrc(src);
            }
        }
        return function () {
            didCancel = true;
            // on component cleanup, we remove the listner
            if (observer && observer.unobserve && imgRef.current) {
                observer.unobserve(imgRef.current);
            }
        };
    }, [src, imageSrc, imgRef]);
    return (react_1.default.createElement(StyledImage, __assign({ width: width, height: height, ref: imgRef, src: imageSrc, alt: alt, onLoad: onLoad, onError: onError, className: Object.keys(classes)
            .filter(function (cls) { return classes[cls]; })
            .join(' ') }, rest)));
};
exports.default = LazyImage;
var templateObject_1, templateObject_2;
